export default {
  // Page titles
  title: 'เทมเพลต',
  new_template: 'สร้างเทมเพลต',
  edit_template: 'แก้ไขเทมเพลต',
  template_detail: 'รายละเอียดเทมเพลต',

  // Descriptions
  description: 'จัดการเทมเพลตเอกสาร',
  new_description: 'สร้างเทมเพลตเอกสารใหม่',
  edit_description: 'แก้ไขการตั้งค่าเทมเพลต',

  // Labels
  labels: {
    template_name: 'ชื่อเทมเพลต',
    document_type: 'ประเภทเอกสาร',
    schema_fields: 'ฟิลด์สคีมา',
    template_settings: 'การตั้งค่าเทมเพลต',
  },

  // Placeholders
  placeholders: {
    template_name: 'เช่น สัญญาเช่ามาตรฐาน',
  },

  // Document types
  types: {
    all: 'ทุกประเภท',
    lease: 'สัญญาเช่า',
    invoice: 'ใบแจ้งหนี้',
    receipt: 'ใบเสร็จ',
    contract: 'สัญญา',
    tax_invoice: 'ใบกำกับภาษี',
    legal_notice: 'หนังสือทวงถาม',
    wht_50_tawi: 'หนังสือรับรองหัก ณ ที่จ่าย (50 ทวิ)',
    expense_reimbursement_receipt: 'ใบสำคัญจ่าย',
  },
  updated_on: 'อัปเดต {{date}}',

  // Editor
  editor: {
    visual_mode: 'ภาพ',
    json_mode: 'JSON',
    template_designer: 'ออกแบบเทมเพลต',
    json_editor: 'แก้ไข JSON',
    full_screen: 'เต็มหน้าจอ',
    exit_full_screen: 'ออกจากเต็มหน้าจอ',
    json: 'JSON',
    preview: 'ดูตัวอย่าง',
    fields_count: 'ฟิลด์ ({{count}})',
    no_fields: 'ยังไม่มีฟิลด์',
    invalid_json: 'JSON ไม่ถูกต้อง: {{error}}',
    show_sample_data: 'แสดงข้อมูลตัวอย่าง',
    hide_sample_data: 'ซ่อนข้อมูลตัวอย่าง',
    editing_in_fullscreen: 'กำลังแก้ไขในโหมดเต็มหน้าจอ ออกจากเต็มหน้าจอเพื่อใช้ตัวแก้ไขนี้',
    json_format_hint: 'แก้ไขโครงสร้างเทมเพลตด้วยรูปแบบ JSON ที่รองรับ pdfme',
    json_placeholder: 'ป้อน JSON เทมเพลต...',
    drag_to_move: 'ลากเพื่อย้าย',
  },

  // Preview
  preview: {
    title: 'ตัวอย่างเทมเพลต',
    json_title: 'JSON เทมเพลต',
    visual: 'ตัวอย่าง',
  },

  // Actions
  actions: {
    add_template: 'เพิ่มเทมเพลต',
    create_template: 'สร้างเทมเพลต',
    copy_json: 'คัดลอก JSON',
    download_json: 'ดาวน์โหลด JSON',
  },

  // Empty states
  empty: {
    title: 'ไม่มีเทมเพลต',
    description: 'สร้างเทมเพลตเอกสารแรกของคุณ',
    not_found: 'ไม่พบเทมเพลต',
  },

  // Setup guide
  setup_guide: {
    title: 'ยินดีต้อนรับสู่เทมเพลต',
    description:
      'เทมเพลตช่วยให้คุณออกแบบเอกสารสำหรับสัญญาเช่า ใบแจ้งหนี้ และใบเสร็จ สร้างเทมเพลตครั้งเดียว แล้วใช้ซ้ำได้ทุกครั้งที่สร้างเอกสาร',
    step_1_title: 'สร้างเทมเพลต',
    step_1_description: 'เลือกประเภทเอกสารและตั้งชื่อ',
    step_2_title: 'ออกแบบด้วยตัวแก้ไขภาพ',
    step_2_description: 'ใช้ตัวออกแบบลากวางเพื่อเพิ่มข้อความ รูปภาพ และองค์ประกอบเลย์เอาต์',
    step_3_title: 'เพิ่มตัวแปรแบบไดนามิก',
    step_3_description:
      'แทรก {{customer.name}} และตัวแปรอื่นๆ ที่จะเติมข้อมูลอัตโนมัติ',
  },

  // Variable Guide
  variables: {
    title: 'ตัวแปรที่ใช้ได้',
    description: 'ใช้ตัวแปรเหล่านี้ในเนื้อหาฟิลด์ข้อความ ค่าจะถูกแทนที่ด้วยข้อมูลจริงเมื่อสร้างเอกสาร',
    copy_hint: 'คลิกเพื่อคัดลอก',
    copied: 'คัดลอกแล้ว!',
    category_property: 'อสังหาริมทรัพย์',
    category_unit: 'ห้อง',
    category_lease: 'สัญญาเช่า',
    category_customer: 'ผู้เช่า',
    category_signature: 'ลายเซ็น',
    'property.name': 'ชื่ออสังหาริมทรัพย์',
    'property.address': 'ที่อยู่อสังหาริมทรัพย์',
    'unit.number': 'หมายเลข/ชื่อห้อง',
    'unit.price': 'ค่าเช่ารายเดือน',
    'lease.deposit': 'เงินประกัน',
    'lease.move_in_fee': 'ค่าแรกเข้า',
    'lease.keycard_deposit': 'เงินมัดจำคีย์การ์ด',
    'lease.started_at': 'วันเริ่มสัญญา',
    'lease.ended_at': 'วันสิ้นสุดสัญญา',
    'lease.lease_code': 'รหัสสัญญาเช่า',
    'lease.lease_code_qr': 'รหัสสัญญาเช่าเป็น QR Code (ใช้กับฟิลด์ barcodes.qrcode)',
    'customer.name': 'ชื่อผู้เช่า',
    'customer.phone': 'เบอร์โทรผู้เช่า',
    'signature.landlord': 'ลายเซ็นผู้ให้เช่า (ฟิลด์รูปภาพ)',
    'signature.tenant': 'ลายเซ็นผู้เช่า (ฟิลด์รูปภาพ)',
  },

  // Messages
  messages: {
    delete_confirm: 'ลบเทมเพลต "{{name}}"? การกระทำนี้ไม่สามารถยกเลิกได้',
    created: 'สร้างเทมเพลตสำเร็จ',
    updated: 'แก้ไขเทมเพลตสำเร็จ',
    deleted: 'ลบเทมเพลตสำเร็จ',
    copied: 'คัดลอก JSON ไปยังคลิปบอร์ดแล้ว',
  },
}
